import React, { useState } from 'react';
import axios from 'axios';
import './FooterMailingList.css';

const FooterMailingList = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { email: email.trim() };
    const apiKey = process.env.REACT_APP_CHATTERS_API_KEY;
    const apiUri = process.env.REACT_APP_CHATTERS_API_URI;

    try {
      const response = await axios.post(
        `${apiUri}/subscribe-to-mailing-list`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKey,
          },
        }
      );
      if (response.status === 200) {
        setMessage('Thank you for subscribing!');
        setEmail('');
      }
    } catch (error) {
      setMessage(
        error.response?.data?.error || 'Something went wrong. Please try again.'
      );
    }
  };

  return (
    <section className="footer-mailing" aria-label="Join our mailing list">
      <h3 className="footer-mailing__heading">JOIN OUR MAILING LIST</h3>
      <p className="footer-mailing__note">Keep up to date with the latest events at Chatters</p>
      <form onSubmit={handleSubmit} className="footer-mailing__form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          className="footer-mailing__input"
          aria-label="Email address"
        />
        <button type="submit" className="footer-mailing__submit">
          Subscribe
        </button>
      </form>
      {message && <p className="footer-mailing__message">{message}</p>}
      <span className="footer-mailing__privacy">We respect your privacy</span>
    </section>
  );
};

export default FooterMailingList;
